import { isRetailer } from "@faire/help-center-utils/serialized-data/getRetailer";

import { QuickAction } from "../types";

import { useActionTypeContextStore } from "./ActionTypeContext";
import { useBrandQuickActions } from "./useBrandQuickActions";
import { useRetailerQuickActions } from "./useRetailerQuickActions";

type ActionTypes = {
  actionTypes: QuickAction[];
  clearActionType: () => void;
  actionType: QuickAction | undefined;
  setActionType: (actionType: QuickAction) => void;
};

export const useActionTypes = (): ActionTypes => {
  const [{ actionType }, setActionTypeContextStore] = useActionTypeContextStore(
    ["actionType"]
  );

  const retailerQuickActions = useRetailerQuickActions();
  const brandQQuickActions = useBrandQuickActions();
  const actions = isRetailer() ? retailerQuickActions : brandQQuickActions;
  const actionTypes = Object.values(actions);

  const clearActionType = () => {
    setActionTypeContextStore({
      actionType: undefined,
    });
  };

  const setActionType = (actionType: QuickAction) => {
    setActionTypeContextStore({
      actionType,
    });
  };

  return {
    actionTypes,
    clearActionType,
    actionType,
    setActionType,
  };
};
